
export class DadosPessoa {
    cpf: string;
    nascimento: Date
}


// WEBPACK FOOTER //
// ./src/app/models/account/dados-pessoa.model.ts